<div class="anpp">
  <div class="content">
    <div class="content-panel">
      <div class="card">
        <div *ngIf="entreprise" class="row title">
          <div class="col">
            <p class="h4 m-3">
              {{ entreprise.raisonSociale }}
            </p>
          </div>
          <div class="col-md-auto"></div>
          <div class="col col-lg-4">
            <button
              type="button"
              *ngIf="entreprise.refSousType.code === 'PO_DEFAUT'"
              (click)="toGroupement()"
              class="btn btn-secondary btnprimary m-3"
            >
              vers Groupement de producteurs
            </button>
          </div>
        </div>

        <ng-container *ngIf="entreprise">
          <ul
            ngbNav
            class="nav-tabs mt-2 border-radius-onglet"
            #nav="ngbNav"
            (navChange)="onTabChange($event, nav)"
          >
            <li ngbNavItem="edit">
              <a ngbNavLink>Identification et coordonnées</a>
              <ng-template ngbNavContent>
                <app-edit-entreprise [id]="id" [estOnglet]="true" #edit>
                </app-edit-entreprise>
              </ng-template>
            </li>

            <li ngbNavItem="listepo" *ngIf="entreprise && entreprise.refSousType.code === 'GP_DEFAUT'">
              <a ngbNavLink>Producteurs organisés</a>
              <ng-template ngbNavContent>
                <app-liste-po [id]="id" [estOnglet]="true" #listepo>
                </app-liste-po>
              </ng-template>
            </li>

            <li ngbNavItem="listecontact" *ngIf="entreprise">
              <a ngbNavLink>Contacts</a>
              <ng-template ngbNavContent>
                <app-liste-contact-entreprise [id]="id" #listecontact>
                </app-liste-contact-entreprise>
              </ng-template>
            </li>

            <li ngbNavItem="listeConseillert" *ngIf="entreprise && entreprise.refSousType.code === 'GP_DEFAUT'">
              <a ngbNavLink>Conseillers</a>
              <ng-template ngbNavContent>
                <app-list-conseiller [id]="id" #listeConseiller>
                </app-list-conseiller>
              </ng-template>
            </li>

            <li ngbNavItem="verger" *ngIf="entreprise">
              <a ngbNavLink>Verger</a>
              <ng-template ngbNavContent>
                <app-verger-entreprise [id]="id" #verger> </app-verger-entreprise>
              </ng-template>
            </li>

            <li ngbNavItem="VAR"
                *ngIf="entreprise && entreprise.refSousType.code === 'PI_DEFAUT' && ongletVergerEco">
              <a ngbNavLink>Vergers écoresponsables</a>
              <ng-template ngbNavContent>
                <app-formulaire-pi [idEngagement]="idEngagement" #vergerEco>
                </app-formulaire-pi>
              </ng-template>
            </li>

            <li ngbNavItem="VAR"
                *ngIf="entreprise && entreprise.refSousType.code === 'GP_DEFAUT' && ongletVergerEco">
              <a ngbNavLink>Vergers écoresponsables</a>
              <ng-template ngbNavContent>
                <app-formulaire-gp [idEngagement]="idEngagement" #vergerEco>
                </app-formulaire-gp>
              </ng-template>
            </li>

            <li ngbNavItem="interaction" *ngIf="entreprise">
              <a ngbNavLink>Interactions</a>
              <ng-template ngbNavContent>
                <app-interactions-entreprise [id]="id" #interaction>
                </app-interactions-entreprise>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-3"></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
